import React, { Component } from 'react'
import { Row, Col, Card, CardGroup, Button, Form } from "react-bootstrap";
import { components } from 'react-select'
import moment from 'moment';
import SelectDropDown from '../../selectdropdown/SelectDropDown';
import TableSearchwithStudentResult from '../../questioners/manage_questin_papers/TableSearchwithStudentResult';
import MultiSelect from "react-multi-select-component";
import { Link, withRouter } from 'react-router-dom';
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import parse, { domToReact } from 'html-react-parser';
import * as Cookies from "es-cookie";
import TotalStudentDataModal from './totalStudentDataModal.jsx';
import SingleStudentDataModal from './singelStudentDataModal.jsx';
import './summary.scss';


const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
      </components.DropdownIndicator>
    )
  );
};

class QuizsummaryHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quiz_exam: "0",
      quiz_exam_value: "",
      class_id: "0",
      class_id_value: "",
      QuizExams: [],
      Classes: [],
      getSectionsArr: [],
      sectiontypes: [],
      sectiontypesvalue: [],
      quizName: "",
      classNameVal: "",
      sectionName: "",
      showSpinner: "hide",
      getQuizResults: "",
      attempted_exam: "started",
      studentResults: [],
      totalStudentDataShow: false,
      singleStudentDataShow: false,
      mobile: "",
      slno: ''
    };

  }

  componentDidMount() {
    let QuizExamArr = [];

    this.props.getQuizCompletedExams.map(item => {
      const newObj = {
        value: item.id,
        label: item.exam_name,
      }
      QuizExamArr.push(newObj);
    });

    this.setState({
      QuizExams: QuizExamArr,
    });
  }

  handleSelect = (val) => {
    this.setState({
      attempted_exam: val,
    })
  }

  selecthandleInputChange = async (ename, evalue) => {
    this.setState({ class_id_value: "", sectiontypesvalue: [] });


    console.log("selecthandleInputChange", ename, evalue);
    const name = ename;
    const value = evalue;

    let getSelectedsections = [];
    let globalSectionsArr = this.props.globals.globalSections;
    let classNewArr = [];
    let sectionNewArr = [];
    let sectiontypesArrr = [];


    if (name == "quiz_exam") {

      this.props.getQuizCompletedExams.map(item => {
        if (item.id == value) {
          getSelectedsections = item.section.split(",");
          let classObj = {};
          if (item.class_id == 1) {
            classObj = {
              value: 1,
              label: "XI",
            }
          } else {
            classObj = {
              value: 1,
              label: "XII",
            }
          }

          classNewArr.push(classObj);
          this.setState({
            quiz_exam_value: {
              value: item.id,
              label: item.exam_name
            },
            class_id_value: classObj

          });
        }

      });

      getSelectedsections.map((sec_id, index) => {
        globalSectionsArr.filter(a => sec_id == a.id).map(item => {
          const newObj = {
            value: item.id,
            label: item.section_name
          }
          sectionNewArr.push(newObj);
          sectiontypesArrr.push(item.id)
        })

      })


      this.setState({
        Classes: classNewArr,
        getSectionsArr: sectionNewArr,
        sectiontypesvalue: sectionNewArr,
        sectiontypes: sectiontypesArrr
      });

    }

    if (name == "class") {
      let classData = this.props.globals.classes.find((a) => a.id == value);
      this.setState({
        class_id_value: {
          value: classData.id,
          label: classData.class
        }
      });
    }

    this.setState({ [name]: value });
  }

  handleMultipleSelectInputChange = (e) => {
    let sectiontypes = Array();
    let sectiontypesvalue = Array();
    if (e != null) {
      for (let i = 0; i < e.length; i++) {
        const sectiontypesval = e[i];
        const newObj = {
          label: sectiontypesval.label,
          value: sectiontypesval.value
        }
        sectiontypesvalue.push(newObj);
        sectiontypes.push(sectiontypesval.value);
      }
      this.setState({
        sectiontypesvalue: sectiontypesvalue,
        sectiontypes: sectiontypes
      });
    }

  }
  getSummaryDetails = async () => {
    this.setState({ quizName: "", classNameVal: "", sectionName: "" });


    if (this.state.examValue == "") {
      this.setState({ quizName: "Please Select Quiz Name" });
      return;
    }
    else if (this.state.classValue == "") {
      this.setState({ classNameVal: "Please Select Class" });
      return;
    } else if (this.state.sectionValue == "") {
      this.setState({ sectionName: "Please Select Section" });
      return;
    }

    this.setState({ showSpinner: "show" });


    const result = await this.props.client.query({
      query: gql` 
          query(
              $institution_id:Int!,
              $exam_paper_id:Int!,
              $section_id:String!
              
              ) {
                getQuizResults(
                     institution_id: $institution_id,
                     exam_paper_id: $exam_paper_id,
                     section_id: $section_id,
                  )
                  {
                    id
                    exam_name
                    scheduled_time
                    class_id
                    average_marks
                    section
                    subject_name
                    total_students
                    duration
                    total_attended
                    total_started
                    marks
                    results{
                      student_name
                      correct_marks
                      negative_marks
                      attempted_exam
                      rank
                      studentAvg
                      className
                      section
                      mobile
                      is_started
                    }
              }
          }
        `,
      variables: {

        institution_id: parseInt(Cookies.get("institutionid")),
        exam_paper_id: parseInt(this.state.quiz_exam),
        section_id: this.state.sectiontypes.toString()

      },
      fetchPolicy: 'network-only'
    });

    const studentResults = await this.props.client.query({
      query: gql` 
          query(
              $exam_paper_id:Int!,
              
              ) {
                getStudent_correct_wrong_results(
                     exam_paper_id: $exam_paper_id,
                  )
                  {
                    slno
                    question
                    option1
                    option2
                    option3
                    option4
                    answer
                    question_id
                    correct_count
                    wrong_count
                    unanswered_count
                    studentResults {
                      name
                      attempt_answer
                      isCorrect
                      mobile
                    }
              }
          }
        `,
      variables: {
        exam_paper_id: parseInt(this.state.quiz_exam),
      },
      fetchPolicy: 'network-only'
    });


    if (result.data.getQuizResults != undefined) {
      this.setState({
        showSpinner: "hide",
        getQuizResults: result.data.getQuizResults,
      });
    }
    if (studentResults.data.getStudent_correct_wrong_results != undefined) {
      this.setState({
        studentResults: studentResults.data.getStudent_correct_wrong_results,
      });
    }

  }



  articlecolumns = [
    {
      dataField: "student_name",
      text: "Student Name",
      sort: true,
    },
    {
      dataField: "section",
      text: "section",
    },
    {
      dataField: "class",
      text: "Class",
    },
    {
      dataField: "average",
      text: "Overall Average",
    },
    {
      dataField: "score",
      text: "Score",
      sort: true,
    },
    {
      dataField: "ranking",
      text: "Rank",
      sort: true
    }
  ];


  resultColumns = [
    {
      dataField: "student_name",
      text: "Student Name",
      sort: true,
    },
    {
      dataField: "section",
      text: "section",
    },
    {
      dataField: "class",
      text: "Class",
    },
    {
      dataField: "average",
      text: "Overall Average",
    },
    {
      dataField: "score",
      text: "Score",
      sort: true,
    },
    {
      dataField: "ranking",
      text: "Rank",
      sort: true
    },
    {
      dataField: "mobile",
      text: "Result",
      formatter: this.actionFormatterStudentName.bind(this)
    },
  ];

  questionColumns = [
    {
      dataField: "index",
      text: "SLNO",
    },
    {
      dataField: "questionID",
      text: "question",
      formatter: this.actionFormatterQuestionData.bind(this),
    },
    {
      dataField: "correctCount",
      text: "Correct",
      sort: true
    },
    {
      dataField: "wrongCount",
      text: "Wrong",
      sort: true
    },
    {
      dataField: "unanswered",
      text: "Unanswered",
      sort: true,
    },
    {
      dataField: "slno",
      text: "Results",
    },
  ];




  tableData(students) {
    const student_data = Array();
    console.log("aravind", students)
    for (let i = 0; i < students.length; i++) {
      let section_Name = "", class_Name = "";
      if (students[i].section == "") {
        section_Name = "-"
      } else {
        section_Name = students[i].section
      }
      if (students[i].className == "") {
        class_Name = "-"
      } else {
        class_Name = students[i].className
      }
      student_data.push({
        student_name: students[i].student_name,
        section: section_Name,
        class: class_Name,
        average: students[i].studentAvg,
        score: students[i].correct_marks - students[i].negative_marks,
        ranking: students[i].rank,
        mobile: students[i].mobile,

      });
    }
    return student_data;
  }

  resultData(resultData) {
    const question_data = Array();
    for (let i = 0; i < resultData.length; i++) {
      question_data.push({
        index: i + 1,
        correctCount: resultData[i].correct_count,
        wrongCount: resultData[i].wrong_count,
        unanswered: resultData[i].unanswered_count,
        questionID: resultData[i].question_id,
        slno: <a onClick={() => this.totalStudentResults(resultData[i].slno)} style={{ color: "blue" }}>View</a>,

      });
    }
    return question_data;
  }

  actionFormatterStudentName(row) {
    return (<>
      <a onClick={() => this.singleStudentResult(row)}>
        <p style={{ color: "blue" }}>View Results</p>
      </a>

    </>)
  }

  actionFormatterQuestionData(rowData) {
    let questionData = this.state.studentResults.filter((item) => item.question_id == rowData);
    return (
      <div className='d-flex'>
        <Card as={Card.Body} className="bg-light ">
          <Row>
            <Col xl={12} lg={12} md={12} sm={12}>
              <Row>
                <Col xl={12} lg={12} md={12} sm={12}>
                  <div>{parse(questionData[0].question)}</div>
                </Col>
              </Row>
              <Row>
                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                  <div className="d-flex align-items-center">
                    <span className='f-16'>A.</span>
                    <div className="ml-2">{parse(questionData[0].option1)}</div>
                  </div>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                  <div className="d-flex align-items-center">
                    <span className='f-16'>B.</span>
                    <div className="ml-2">{parse(questionData[0].option2)}</div>
                  </div>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                  <div className="d-flex align-items-center">
                    <span className='f-16'>C.</span>
                    <div className="ml-2">{parse(questionData[0].option3)}</div>
                  </div>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                  <div className="d-flex align-items-center">
                    <span className='f-16'>D.</span>
                    <div className="ml-2">{parse(questionData[0].option4)}</div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>
    )
  }

  singleStudentResult = (row) => {
    this.setState({
      singleStudentDataShow: true,
      mobile: row
    })
  }
  totalStudentResults = (data) => {
    console.log("sssssssss", data)
    this.setState({
      attempted_exam: "totalStudentResults",
      totalStudentDataShow: true,
      slno: data
    })
  }

  render() {
    console.log("sssss", this.state)
    let sectionselectall = true;
    let sectionlabelledBy = "Select";
    let sectiondisableSearch = false;
    if (this.state.getSectionsArr.length > 0) {
      sectionselectall = true;
      sectiondisableSearch = false;
    }
    else {
      sectiondisableSearch = true;
      sectionselectall = false;
      sectionlabelledBy = "No Options"
    }


    let stateFilterData1 = [];
    if (this.state.getQuizResults != "") {
      let filterData = this.state.getQuizResults.filter(item2 => item2.id == this.state.quiz_exam);
      console.log("filterdata", filterData);
      let stateFilterData = [];
      if (this.state.section != "" && filterData.length > 0) {
        stateFilterData = filterData[0].results.map((item) => {
          if (item != undefined) {
            return item
          }
        })
      }

      if (this.state.attempted_exam == "notStarted") {
        stateFilterData1 = stateFilterData.filter((item) => item.attempted_exam == false)
      } else if (this.state.attempted_exam == "completed") {
        stateFilterData1 = stateFilterData.filter((item) => item.attempted_exam == true)
      } else if (this.state.attempted_exam == "started") {
        stateFilterData1 = stateFilterData.filter((item) => item.is_started == true)
      } else if (this.state.attempted_exam == "totalStudentResults") {
        stateFilterData1 = this.state.studentResults
      } else {
        stateFilterData1 = stateFilterData
      }
    }

    console.log("aaaa", this.state.attempted_exam)

    return (

      <div className='quiz_section'>
        <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '18px 22px', borderBottom: '1px solid #f1f5f9' }}>
            <div style={{ background: '#f5f3ff', color: '#7c3aed', borderRadius: 10, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>
              <i className="fal fa-chart-bar" />
            </div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 16, color: '#1f2937', letterSpacing: '-0.01em' }}>Quiz Summary</div>
              <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>Result analysis and student performance for completed quizzes</div>
            </div>
          </div>
          <div style={{ padding: '18px 22px' }}>
        <Row>
          <Col sm={12}>
            <Card as={Card.Body} className="p-3" style={{ boxShadow: 'none', border: '1px solid #e5e7eb' }}>
              <Form>
                <Row>
                  <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="slectQuiz">
                    <Form.Label className="text-uppercase font-weight-bold">Quiz Name <span className='errorCls'>{this.state.quizName}</span></Form.Label>
                    <SelectDropDown
                      stateData={this.state.quiz_exam_value}
                      handleChange={this.selecthandleInputChange}
                      name="quiz_exam"
                      options={this.state.QuizExams}
                      placeholderName={'Select Quiz'}
                      dropdownIndicator={{ DropdownIndicator }}
                    />
                  </Form.Group>
                  {
                    Cookies.get("institutionid") != 19 ? (
                      <>
                        <Form.Group as={Col} xl={3} lg={3} md={3} sm={12} controlId="slectClass">
                          <Form.Label className="text-uppercase font-weight-bold">Class <span className='errorCls'>{this.state.classNameVal}</span></Form.Label>
                          <SelectDropDown
                            stateData={this.state.class_id_value}
                            handleChange={this.selecthandleInputChange}
                            name="class"
                            options={this.state.Classes}
                            placeholderName={'Select Class'}
                            dropdownIndicator={{ DropdownIndicator }}
                          />
                        </Form.Group>
                        <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="SelectSections">
                          <Form.Label className="text-uppercase font-weight-bold">Section <span className='errorCls'>{this.state.sectionName}</span></Form.Label>
                          <MultiSelect
                            overrideStrings={{
                              "allItemsAreSelected": "All Sections are selected.",
                              "selectSomeItems": sectionlabelledBy
                            }
                            }
                            disableSearch={sectiondisableSearch}
                            hasSelectAll={sectionselectall}
                            options={this.state.getSectionsArr}
                            value={this.state.sectiontypesvalue}
                            onChange={(e) => this.handleMultipleSelectInputChange(e)}
                            labelledBy={"Section"}
                          />
                        </Form.Group>
                        <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="SelectSections">
                          <Button type="button" className="btn btn-light-blue float-right mt-4" onClick={(e) => this.getSummaryDetails()}>Get Details</Button>
                        </Form.Group>
                      </>
                    ) : (
                      <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="SelectSections">
                        <Button type="button" className="btn btn-light-blue float-left mt-4" onClick={(e) => this.getSummaryDetails()}>Get Details</Button>
                      </Form.Group>
                    )
                  }

                </Row>

              </Form>
              {
                this.state.getQuizResults == "" ?
                  (
                    <Row>
                      <Col sm={12} className={this.state.showSpinner == "show" ? "showSpinnerCls text-center" : "hideSpinnerCls text-center"}>
                        <div class="spinner-border text-primary text-center loading-img-center"></div>
                      </Col>
                    </Row>
                  )
                  :
                  ("")
              }
              {
                this.state.getQuizResults != "" ?
                  (
                    <>
                      <h4 className='mt-4 text-center text-capitalize'>Quiz Details ( <span className='color_blue'>{this.state.getQuizResults[0].subject_name}</span> )</h4>
                      <p className='text-center font-weight-bold font_16'>(  Exam Date : {moment.unix(this.state.getQuizResults[0].scheduled_time).format("DD-MM-YYYY LT")} )</p>
                      <h5 className='mt-3'>Summary : </h5>
                      <div className='mainBlockUl mt-2'>
                        <ul className='list-inline blocksLi'>
                          <li class="color_bg_white br_yellow">
                            <div class="row">
                              <div class="col-sm-9">
                                <h6 class="font_16">Duration</h6>
                              </div>
                              <div class="col-sm-3 float-right">
                                <i class="far fa-clock f-24 bg_yellow"></i>
                              </div>
                              <div class="col-sm-12">
                                <h5 class="mt-2 text-center">{this.state.getQuizResults[0].duration + " Min"}</h5>
                              </div>
                            </div>
                          </li>
                          <li class="color_bg_white br_green">
                            <div class="row">
                              <div class="col-sm-9">
                                <h6 class="font_16">Started</h6>
                              </div>
                              <div class="col-sm-3 float-right">
                                <i class="far fa-user-check f-24 bg_green left_pos"></i>
                              </div>
                              <div class="col-sm-12">
                                <h5 class="mt-2 text-center">{this.state.getQuizResults[0].total_started + "/" + this.state.getQuizResults[0].total_students}</h5>
                              </div>
                            </div>
                          </li>
                          <li class="color_bg_white br_red">
                            <div class="row">
                              <div class="col-sm-9">
                                <h6 class="font_16">Not Started</h6>
                              </div>
                              <div class="col-sm-3 float-right">
                                <i class="far fa-user-times f-24 bg_red left_pos"></i>
                              </div>
                              <div class="col-sm-12">
                                <h5 class="mt-2 text-center">{this.state.getQuizResults[0].total_students - this.state.getQuizResults[0].total_attended + "/" + this.state.getQuizResults[0].total_students}</h5>
                              </div>
                            </div>
                          </li>
                          <li class="color_bg_white br_orange">
                            <div class="row">
                              <div class="col-sm-8">
                                <h6 class="font_16">Marks</h6>
                              </div>
                              <div class="col-sm-4 float-right">
                                <i class="far fa-file-alt f-24 bg_orange"></i>
                              </div>
                              <div class="col-sm-12">
                                <h5 class="mt-2 text-center">{this.state.getQuizResults[0].marks}</h5>
                              </div>
                            </div>
                          </li>
                          <li class="color_bg_white br_orange">
                            <div class="row">
                              <div class="col-sm-9">
                                <h6 class="font_16">Avg Marks</h6>
                              </div>
                              <div class="col-sm-3 float-right">
                                <i class="far fa-file-alt f-24 bg_orange"></i>
                              </div>
                              <div class="col-sm-12">
                                <h5 class="mt-2 text-center">{this.state.getQuizResults[0].average_marks}</h5>
                              </div>
                            </div>
                          </li>

                        </ul>
                      </div>

                      <Row>
                        <Col sm={4} className='mt-5'>
                          <h5 className='mt-2'>Student Details</h5>
                        </Col>
                        <Col sm={8} className='mt-5'>
                          <ul className='d-flex justify-content-end question_sel_cls'>
                            {
                              Cookies.get("institutionid") != 19 ? (
                                <>
                                  <li className={this.state.attempted_exam == "started" ? "active mr-2" : "mr-4"} onClick={() => this.handleSelect("started")}>Started</li>
                                  <li className={this.state.attempted_exam == "notStarted" ? "active mr-2" : "mr-4"} onClick={() => this.handleSelect("notStarted")}>Not Started</li>
                                  <li className={this.state.attempted_exam == "completed" ? "active mr-2" : "mr-4"} onClick={() => this.handleSelect("completed")}>Completed</li>
                                  <li className={this.state.attempted_exam == "totalStudentResults" ? "active mr-2" : "mr-4"} onClick={() => this.handleSelect("totalStudentResults")}>Result Analysis</li>
                                </>
                              ) : (
                                <>
                                  <li className={this.state.attempted_exam == "started" ? "active mr-2" : "mr-4"} onClick={() => this.handleSelect("started")}>Started</li>
                                  <li className={this.state.attempted_exam == "completed" ? "active mr-2" : "mr-4"} onClick={() => this.handleSelect("completed")}>Completed</li>
                                  <li className={this.state.attempted_exam == "totalStudentResults" ? "active mr-2" : "mr-4"} onClick={() => this.handleSelect("totalStudentResults")}>Result Analysis</li>

                                </>

                              )}
                          </ul>
                        </Col>
                      </Row>
                      {
                        stateFilterData1.length == "" ?
                          (
                            <div className="table-responsive mt-2">
                              <table className="table table-bordered table_custom_cls">
                                <thead>
                                  <tr>
                                    <th>Student Name</th>
                                    <th>Section</th>
                                    <th>Class</th>
                                    <th>OverAll Average</th>
                                    <th>Score</th>
                                    <th>Rank</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colSpan={6}>No Data Available...</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          )
                          :
                          (
                            <TableSearchwithStudentResult
                              parentData={this.state.attempted_exam == 'totalStudentResults' ? this.resultData(stateFilterData1) : this.tableData(stateFilterData1)}
                              particlecolumns={this.state.attempted_exam == 'totalStudentResults' ? this.questionColumns : this.state.attempted_exam == 'completed' ? this.resultColumns : this.articlecolumns}
                            //defaultSorted={this.rankDefaultsorted}
                            />
                          )
                      }

                    </>
                  )
                  :
                  ("")
              }


            </Card>
          </Col>
        </Row>
          </div>
        </div>
        <TotalStudentDataModal
          show={this.state.totalStudentDataShow}
          onHide={() => this.setState({ totalStudentDataShow: false, slno: '' })}
          data={this.state}
        />
        <SingleStudentDataModal
          show={this.state.singleStudentDataShow}
          onHide={() => this.setState({ singleStudentDataShow: false })}
          stateData={this.state}
        />
      </div>
    )

  }
}


export default withRouter(withApollo(QuizsummaryHome));